import { ChangeEvent, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IComponentModal } from "../../../Modais/IModalComponent";
import ModalComponent from "../../../Modais";
import { faStackExchange } from "@fortawesome/free-brands-svg-icons";
import { IAtendimentoRepasseCaso } from "../../../../Interfaces/Repasse/AtendimentosRepasse/AtendimentosRepasse";
import "./styles.css";
import moment from "moment";
import { useForm, useFormContext } from "react-hook-form";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import {
    ListarVinculacaoController,
    ListarModalidadeController,
    ListarCatorioController,
} from "../../../../Controllers/Repasse/GestaoDadosRepasse/GestaoDadosRepasse";
import {
    MoneyReaisFieldMask,
    formatterContratoCEF,
} from "../../../../Validations/InputMasks";
import UnForm from "../../../Form";
import { AlterarDadosEmMassaRepasseController } from "../../../../Controllers/Repasse/GestaoRepasse/GestaoRepasseController";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { useHistoricoContext } from "../../../../Context/Historico";
import OrSpinner from "../../../Utils/OrSpinner";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";

interface IAlterarDadosCasosEmMassaRepasse {
    setShow: (show: boolean) => void;
    update: () => void;
    ID_CASOS?: Array<number>;
    filter?: any;

    controller: () => Promise<any>;

    ID_TIPO_CASO: number;
}

export default function AlterarDadosCasosEmMassaRepasse(
    props: IAlterarDadosCasosEmMassaRepasse
) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    return (
        <>
            <ul className="sticky-toolbar nav flex-column pl-2 pr-2 pt-3 pb-3 stickyMarginPx">
                <li
                    className="nav-item"
                    data-toggle="tooltip"
                    title="Alterar Dados Repasse em Massa"
                    data-placement="left"
                    data-original-title="Alterar Dados"
                >
                    <button
                        className="btn btn-sm btn-icon btn-bg-light btn-icon-info btn-hover-success"
                        onClick={() => {
                            setModal({
                                Component: () => (
                                    <RepasseDadosComponent {...props} />
                                ),
                                IconHeader: faStackExchange,
                                headerComponent:
                                    "Alterar Dados Repasse em Massa",
                                size: "xl",
                            });
                            setShow(true);
                        }}
                    >
                        <FontAwesomeIcon icon={faStackExchange} />
                    </button>
                </li>
            </ul>

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}

function RepasseDadosComponent(props: IAlterarDadosCasosEmMassaRepasse) {
    const formMethods = useFormContext<IAtendimentoRepasseCaso>();
    const { reset } = useForm<IAtendimentoRepasseCaso>();

    const { ReloadHistorico } = useHistoricoContext();

    const { controller } = props;

    function geradorMascaraFinanceira(
        inputName: keyof IAtendimentoRepasseCaso
    ) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            const mask = MoneyReaisFieldMask(e);
            formMethods?.setValue(inputName, mask);
        };
    }

    function formatadorDatas(inputName: keyof IAtendimentoRepasseCaso) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            let data: string | string[] = e.target.value;

            if (data.length !== 10) {
                let nvDate: string | string[] = data.split("-");
                nvDate[0] = nvDate[0].substring(1, 5);
                nvDate = nvDate.join("-");
                data = nvDate;
            }

            formMethods?.setValue(inputName, moment(data).format("YYYY-MM-DD"));
        };
    }

    const { value: listarAtendimentos, loading: listarAtendimentosLoading } =
        useAsyncEffect(() => controller(), []);

    const { execute: AlterarTodosDados, loading: AlterarDadosEmMassaLoading } =
        useAsyncCallback(AlterarDadosEmMassaRepasseController);

    function handleAlterarFormSubmit(formData: IAtendimentoRepasseCaso) {
        if (listarAtendimentos)
            AlterarTodosDados({
                ID_CASOS: listarAtendimentos?.map((caso: any) => caso.ID_CASO),
                casoRepasseDados: {
                    ...formData,
                    ID_CASO: formData.ID_CASO,
                    DS_BANCO: formData.DS_BANCO,
                    DS_MODALIDADE: formData.DS_MODALIDADE,
                    DT_ASSINATURA_CAIXA: formData.DT_ASSINATURA_CAIXA,
                    DT_ASSINATURA_ERP: formData.DT_ASSINATURA_ERP,
                    DT_CONFORMIDADE_CEHOP: formData.DT_CONFORMIDADE_CEHOP,
                    DT_DISTRATO: formData.DT_DISTRATO,
                    DT_EMISSAO_ERP: formData.DT_EMISSAO_ERP,
                    DT_EMISSAO_GUIA_ITBI: formData.DT_EMISSAO_GUIA_ITBI,
                    DT_ENTRADA: formData.DT_ENTRADA,
                    DT_ENVIO_CEHOP: formData.DT_ENVIO_CEHOP,
                    DT_ENVIO_PARA_FINANCEIRO: formData.DT_ENVIO_PARA_FINANCEIRO,
                    DT_LIBERACAO_CARTORIO: formData.DT_LIBERACAO_CARTORIO,
                    DT_MINUTA_CAIXA: formData.DT_MINUTA_CAIXA,
                    DT_ORCAMENTO_CARTORIO: formData.DT_ORCAMENTO_CARTORIO,
                    DT_PAGAMENTO: formData.DT_PAGAMENTO,
                    DT_PRENOTACAO: formData.DT_PRENOTACAO,
                    DT_PREVISAO_CONFORMIDADE: formData.DT_PREVISAO_CONFORMIDADE,
                    DT_PREVISAO_SAIDA: formData.DT_PREVISAO_SAIDA,
                    DT_RECEBIMENTO_COMPROVANTE:
                        formData.DT_RECEBIMENTO_COMPROVANTE,
                    DT_RECEBIMENTO_GARANTIA_CEHOP:
                        formData.DT_RECEBIMENTO_GARANTIA_CEHOP,
                    DT_RECEBIMENTO_KIT: formData.DT_RECEBIMENTO_KIT,
                    DT_REGISTRO_CONFORME: formData.DT_REGISTRO_CONFORME,
                    DT_RETIRADA: formData.DT_RETIRADA,
                    DT_SOLICITACAO_ISENCAO_ITBI:
                        formData.DT_SOLICITACAO_ISENCAO_ITBI,
                    DT_SOLICITACAO_ITBI: formData.DT_SOLICITACAO_ITBI,
                    DT_SOLICITACAO_QUITACAO_ITBI:
                        formData.DT_SOLICITACAO_QUITACAO_ITBI,
                    DT_VALIDADE_SICAQ: formData.DT_VALIDADE_SICAQ,
                    ID_AGENCIA_VINCULACAO: formData.ID_AGENCIA_VINCULACAO,
                    ID_BANCO: formData.ID_BANCO,
                    ID_CARTORIO: formData.ID_CARTORIO,
                    ID_CASO_REPASSE_DADOS: formData.ID_CASO_REPASSE_DADOS,
                    ID_CASO_VENDAS: formData.ID_CASO_VENDAS,
                    ID_PRODUTO: formData.ID_PRODUTO,
                    ID_TIPO_MODALIDADE: formData.ID_TIPO_MODALIDADE,
                    ID_USUARIO_CCA: formData.ID_USUARIO_CCA,
                    ID_USUARIO_RESPONSAVEL: formData.ID_USUARIO_RESPONSAVEL,
                    NR_CONTRATO: formData.NR_CONTRATO,
                    NR_MATRICULA: formData.NR_MATRICULA,
                    NR_PROTOCOLO: formData.NR_PROTOCOLO,
                    VL_A_CONFIRMAR: formData.VL_A_CONFIRMAR,
                    VL_A_CONFIRMAR_CONFIRMADO:
                        formData.VL_A_CONFIRMAR_CONFIRMADO,
                    VL_A_CONFIRMAR_MAX: formData.VL_A_CONFIRMAR_MAX,
                    VL_DESPESAS_REGISTRO: formData.VL_DESPESAS_REGISTRO,
                    VL_EMULENTOS: formData.VL_EMULENTOS,
                    VL_FGTS: formData.VL_FGTS,
                    VL_FGTS_CONFIRMADO: formData.VL_FGTS_CONFIRMADO,
                    VL_FGTS_CONFIRMADO_MAX: formData.VL_FGTS_CONFIRMADO_MAX,
                    VL_FINANCIAMENTO: formData.VL_FINANCIAMENTO,
                    VL_FINANCIAMENTO_CONFIRMADO:
                        formData.VL_FINANCIAMENTO_CONFIRMADO,
                    VL_FINANCIAMENTO_CONFIRMADO_MAX:
                        formData.VL_FINANCIAMENTO_CONFIRMADO_MAX,
                    VL_ITBI: formData.VL_ITBI,
                    VL_LAUDEMIO: formData.VL_LAUDEMIO,
                    VL_ORIGINAL: formData.VL_ORIGINAL,
                    VL_RECURSO_LIBERADO: formData.VL_RECURSO_LIBERADO,
                    VL_RECURSOS_PROPRIOS: formData.VL_RECURSOS_PROPRIOS,
                    VL_RECURSOS_PROPRIOS_MAX: formData.VL_RECURSOS_PROPRIOS_MAX,
                    VL_SUBSIDIO: formData.VL_SUBSIDIO,
                    VL_SUBSIDIO_CONFIRMADO: formData.VL_SUBSIDIO_CONFIRMADO,
                    VL_SUBSIDIO_CONFIRMADO_MAX:
                        formData.VL_SUBSIDIO_CONFIRMADO_MAX,
                    VL_TERRENO: formData.VL_TERRENO,
                    VL_TOTAL_ERP: formData.VL_TOTAL_ERP,
                },
            }).then(() => {
                props.setShow(false);
                props.update();
                reset();
                if (ReloadHistorico) ReloadHistorico();
            });
    }

    return (
        <div className="viewFields w-100 p-4">
            <OrSpinner
                loading={
                    listarAtendimentosLoading || AlterarDadosEmMassaLoading
                }
                spinner="capys"
            >
                <UnForm handleSubmit={handleAlterarFormSubmit} className="row">
                    <div className="d-flex row col-12 justify-content-between align-items-center p-4">
                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Compra e Venda:"
                                name="VL_A_CONFIRMAR"
                                registerOptions={{
                                    setValueAs: (v: string) => {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    },
                                }}
                                onChange={geradorMascaraFinanceira(
                                    "VL_A_CONFIRMAR"
                                )}
                            ></UnForm.Input>
                        </div>
                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Financiamento"
                                name="VL_FINANCIAMENTO"
                                registerOptions={{
                                    setValueAs: (v: string) => {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    },
                                }}
                                onChange={geradorMascaraFinanceira(
                                    "VL_FINANCIAMENTO"
                                )}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="FGTS"
                                name="VL_FGTS"
                                registerOptions={{
                                    setValueAs: (v: string) => {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    },
                                }}
                                onChange={geradorMascaraFinanceira("VL_FGTS")}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Subsídio / Subvenção:"
                                name="VL_SUBSIDIO"
                                registerOptions={{
                                    setValueAs: (v: string) => {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    },
                                }}
                                onChange={geradorMascaraFinanceira(
                                    "VL_SUBSIDIO"
                                )}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Recursos Próprios:"
                                name="VL_RECURSOS_PROPRIOS"
                                registerOptions={{
                                    setValueAs: (v: string) => {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    },
                                }}
                                onChange={geradorMascaraFinanceira(
                                    "VL_RECURSOS_PROPRIOS"
                                )}
                            ></UnForm.Input>
                        </div>
                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="ITBI:"
                                name="VL_ITBI"
                                registerOptions={{
                                    setValueAs: (v: string) => {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    },
                                }}
                                onChange={geradorMascaraFinanceira("VL_ITBI")}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Emolumentos"
                                name="VL_EMULENTOS"
                                registerOptions={{
                                    setValueAs: (v: string) => {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    },
                                }}
                                onChange={geradorMascaraFinanceira(
                                    "VL_EMULENTOS"
                                )}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Laudêmio"
                                name="VL_LAUDEMIO"
                                registerOptions={{
                                    setValueAs: (v: string) => {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    },
                                }}
                                onChange={geradorMascaraFinanceira(
                                    "VL_LAUDEMIO"
                                )}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Outras Certidões"
                                name="VL_DESPESAS_REGISTRO"
                                registerOptions={{
                                    setValueAs: (v: string) => {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    },
                                }}
                                onChange={geradorMascaraFinanceira(
                                    "VL_DESPESAS_REGISTRO"
                                )}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.LazySelect
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="CCA"
                                name="ID_USUARIO_CCA"
                                controller={ListarUsuariosController}
                                getKeyValue={(u) => u.ID_USUARIO}
                                getDS={(u) => u.DS_NOME}
                            ></UnForm.LazySelect>
                        </div>

                        <div className="col-md-3">
                            <UnForm.LazySelect
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Agência"
                                name="ID_AGENCIA_VINCULACAO"
                                controller={ListarVinculacaoController}
                                getKeyValue={(v) => v.ID_AGENCIA_VINCULACAO}
                                getDS={(v) => v.DS_AGENCIA_VINCULO}
                            ></UnForm.LazySelect>
                        </div>

                        <div className="col-md-3">
                            <UnForm.LazySelect
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Modalidade"
                                name="ID_TIPO_MODALIDADE"
                                controller={ListarModalidadeController}
                                getKeyValue={(m) => m.ID_TIPO_MODALIDADE}
                                getDS={(m) => m.DS_TIPO_MODALIDADE}
                            ></UnForm.LazySelect>
                        </div>
                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="N° Contrato"
                                name="NR_CONTRATO"
                                maxLength={16}
                                onChange={(e) => formatterContratoCEF(e)}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Matrícula"
                                name="NR_MATRICULA"
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.LazySelect
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Cartório"
                                name="ID_CARTORIO"
                                controller={ListarCatorioController}
                                getDS={(c) => c.DS_CARTORIO}
                                getKeyValue={(c) => c.ID_CARTORIO}
                            ></UnForm.LazySelect>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="N° Protocolo"
                                name="NR_PROTOCOLO"
                            ></UnForm.Input>
                        </div>

                        <hr className="col-12" />

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Emissão RP"
                                name="DT_EMISSAO_ERP"
                                type={"date"}
                                onChange={formatadorDatas("DT_EMISSAO_ERP")}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Assinatura RP"
                                name="DT_ASSINATURA_ERP"
                                type={"date"}
                                onChange={formatadorDatas("DT_ASSINATURA_ERP")}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Validade Sicaq"
                                name="DT_VALIDADE_SICAQ"
                                type={"date"}
                                onChange={formatadorDatas("DT_VALIDADE_SICAQ")}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Minuta CEF"
                                name="DT_MINUTA_CAIXA"
                                type={"date"}
                                onChange={formatadorDatas("DT_MINUTA_CAIXA")}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Assinatura CEF"
                                name="DT_ASSINATURA_CAIXA"
                                type={"date"}
                                onChange={formatadorDatas(
                                    "DT_ASSINATURA_CAIXA"
                                )}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Data de Entrada"
                                name="DT_ENTRADA"
                                type={"date"}
                                onChange={formatadorDatas("DT_ENTRADA")}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Kit Registro"
                                name="DT_RECEBIMENTO_KIT"
                                type={"date"}
                                onChange={formatadorDatas("DT_RECEBIMENTO_KIT")}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Solicitação ITBI"
                                name="DT_SOLICITACAO_ITBI"
                                type={"date"}
                                onChange={formatadorDatas(
                                    "DT_SOLICITACAO_ITBI"
                                )}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Solicitação Isenção"
                                name="DT_SOLICITACAO_ISENCAO_ITBI"
                                type={"date"}
                                onChange={formatadorDatas(
                                    "DT_SOLICITACAO_ISENCAO_ITBI"
                                )}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Emissão Guia ITBI"
                                name="DT_EMISSAO_GUIA_ITBI"
                                onChange={formatadorDatas(
                                    "DT_EMISSAO_GUIA_ITBI"
                                )}
                                type="date"
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Envio ITBI Financeiro"
                                name="DT_SOLICITACAO_QUITACAO_ITBI"
                                onChange={formatadorDatas(
                                    "DT_SOLICITACAO_QUITACAO_ITBI"
                                )}
                                type="date"
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Pagamento ITBI"
                                name="DT_PAGAMENTO"
                                onChange={formatadorDatas("DT_PAGAMENTO")}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Comprovante ITBI"
                                name="DT_RECEBIMENTO_COMPROVANTE"
                                onChange={formatadorDatas(
                                    "DT_RECEBIMENTO_COMPROVANTE"
                                )}
                                type="date"
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Data de Previsão de Conformidade"
                                name="DT_PREVISAO_CONFORMIDADE"
                                onChange={formatadorDatas(
                                    "DT_PREVISAO_CONFORMIDADE"
                                )}
                                type="date"
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Orçamento Cartório"
                                name="DT_ORCAMENTO_CARTORIO"
                                onChange={formatadorDatas(
                                    "DT_ORCAMENTO_CARTORIO"
                                )}
                                type="date"
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Envio Orç. Financeiro"
                                name="DT_ENVIO_PARA_FINANCEIRO"
                                type={"date"}
                                onChange={formatadorDatas(
                                    "DT_ENVIO_PARA_FINANCEIRO"
                                )}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Prenotação"
                                name="DT_PRENOTACAO"
                                type="date"
                                onChange={formatadorDatas("DT_PRENOTACAO")}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Registro"
                                name="DT_REGISTRO_CONFORME"
                                onChange={formatadorDatas(
                                    "DT_REGISTRO_CONFORME"
                                )}
                                type="date"
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Liberação Cartório"
                                name="DT_LIBERACAO_CARTORIO"
                                onChange={formatadorDatas(
                                    "DT_LIBERACAO_CARTORIO"
                                )}
                                type="date"
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Retirada Cartório"
                                name="DT_RETIRADA"
                                onChange={formatadorDatas("DT_RETIRADA")}
                                type="date"
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Data de Previsão de Saída"
                                name="DT_PREVISAO_SAIDA"
                                onChange={formatadorDatas("DT_PREVISAO_SAIDA")}
                                type="date"
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Envio P/ CEHOP"
                                name="DT_ENVIO_CEHOP"
                                type={"date"}
                                onChange={formatadorDatas("DT_ENVIO_CEHOP")}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Garantia Conforme"
                                name="DT_CONFORMIDADE_CEHOP"
                                type={"date"}
                                onChange={formatadorDatas(
                                    "DT_CONFORMIDADE_CEHOP"
                                )}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Distrato"
                                name="DT_DISTRATO"
                                type={"date"}
                                onChange={formatadorDatas("DT_DISTRATO")}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.LazySelect
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="CCA"
                                name="ID_USUARIO_CCA"
                                controller={ListarUsuariosController}
                                getKeyValue={(u) => u.ID_USUARIO}
                                getDS={(u) => u.DS_NOME}
                            ></UnForm.LazySelect>
                        </div>

                        <div className="col-md-3">
                            <UnForm.LazySelect
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Agência"
                                name="ID_AGENCIA_VINCULACAO"
                                controller={ListarVinculacaoController}
                                getKeyValue={(v) => v.ID_AGENCIA_VINCULACAO}
                                getDS={(v) => v.DS_AGENCIA_VINCULO}
                            ></UnForm.LazySelect>
                        </div>

                        <div className="col-md-3">
                            <UnForm.LazySelect
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Modalidade"
                                name="ID_TIPO_MODALIDADE"
                                controller={ListarModalidadeController}
                                getKeyValue={(m) => m.ID_TIPO_MODALIDADE}
                                getDS={(m) => m.DS_TIPO_MODALIDADE}
                            ></UnForm.LazySelect>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="N° Contrato"
                                name="NR_CONTRATO"
                                maxLength={16}
                                onChange={(e) => formatterContratoCEF(e)}
                            ></UnForm.Input>
                        </div>

                        <div className="col-md-3">
                            <UnForm.Input
                                wrapperClassName="p-2 col-12 mb-3"
                                className="mb-4"
                                label="Matrícula"
                                name="NR_MATRICULA"
                            ></UnForm.Input>
                        </div>

                        <UnForm.SubmitButton
                            className="btn btn-success col-12"
                            type="submit"
                            color="success"
                            icon={faStackExchange}
                            wrapperClassName="w-100"
                            // loading={}
                            // disabled={}
                            loadingSize={"sm"}
                        >
                            Alterar Todos os Dados
                        </UnForm.SubmitButton>
                    </div>
                </UnForm>
            </OrSpinner>
        </div>
    );
}
